import { render } from "./vehiclewisestockreporttable.vue?vue&type=template&id=1b13e4ea&scoped=true"
import script from "./vehiclewisestockreporttable.vue?vue&type=script&lang=js"
export * from "./vehiclewisestockreporttable.vue?vue&type=script&lang=js"

import "./vehiclewisestockreporttable.vue?vue&type=style&index=0&id=1b13e4ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b13e4ea"]])

export default __exports__